import React from 'react';
import { Check, Trash2, Loader2 } from 'lucide-react';

const ContactsTab = ({ contacts, loadingData, token, onRefresh, onDashboardRefresh, apiBaseUrl }) => {
  const markAsRead = async (id) => {
    await fetch(`${apiBaseUrl}/api/admin/contacts/${id}/read`, { 
      method: 'PUT', 
      headers: { 'Authorization': `Bearer ${token}` } 
    });
    onRefresh();
    onDashboardRefresh();
  };

  const deleteContact = async (id) => {
    if (window.confirm('Are you sure you want to delete this message?')) {
      await fetch(`${apiBaseUrl}/api/admin/contacts/${id}`, { 
        method: 'DELETE', 
        headers: { 'Authorization': `Bearer ${token}` } 
      });
      onRefresh();
      onDashboardRefresh();
    }
  };

  return (
    <div className="bg-white shadow-lg">
      <div className="p-6 border-b flex justify-between items-center">
        <div>
          <h2 className="text-xl text-[#1a2f23]">Contact Messages</h2>
          <p className="text-sm text-[#5a6d62]">Manage messages from the contact form</p>
        </div>
      </div>
      {loadingData ? (
        <div className="p-8 text-center">
          <Loader2 className="w-8 h-8 text-[#c5a572] animate-spin mx-auto" />
        </div>
      ) : contacts.length === 0 ? (
        <div className="p-8 text-center text-[#5a6d62]">No messages yet</div>
      ) : (
        <div className="divide-y divide-gray-100">
          {contacts.map(c => (
            <div key={c.id} className={`p-6 ${!c.is_read ? 'bg-[#c5a572]/5 border-l-4 border-[#c5a572]' : ''}`}>
              <div className="flex justify-between items-start mb-3">
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-medium text-[#1a2f23]">{c.name}</h3>
                    {!c.is_read && <span className="text-xs bg-[#c5a572] text-white px-2 py-0.5 rounded">New</span>}
                  </div>
                  <p className="text-sm text-[#5a6d62]">{c.email} {c.phone && `• ${c.phone}`}</p>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-[#5a6d62]">{new Date(c.created_at).toLocaleDateString()}</span>
                  {!c.is_read && (
                    <button
                      onClick={() => markAsRead(c.id)}
                      className="text-green-600 hover:text-green-800 p-1"
                      title="Mark as read"
                    >
                      <Check className="w-4 h-4" />
                    </button>
                  )}
                  <button
                    onClick={() => deleteContact(c.id)}
                    className="text-red-500 hover:text-red-700 p-1"
                    title="Delete message"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <p className="text-sm font-medium text-[#c5a572] mb-2">Subject: {c.subject}</p>
              <p className="text-sm text-[#5a6d62] bg-[#f8f6f1] p-3 rounded">{c.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactsTab;
